import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type ApiIconProps = CommonSvgProps

const ApiIcon: React.FC<ApiIconProps> = React.forwardRef<SVGSVGElement, ApiIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 110 80" {...props} ref={ref} color="none">
      <path
        d="M16.8207 11.7421C16.8207 13.8699 15.0955 15.5959 12.967 15.5959C10.8385 15.5959 9.11328 13.8699 9.11328 11.7421C9.11328 9.61352 10.8385 7.88843 12.967 7.88843C15.0955 7.88843 16.8207 9.6136 16.8207 11.7421Z"
        fill="#53A2D9"
      />
      <path
        d="M27.2758 11.7421C27.2758 13.8699 25.5506 15.5959 23.4221 15.5959C21.2943 15.5959 19.5684 13.8699 19.5684 11.7421C19.5684 9.61352 21.2944 7.88843 23.4221 7.88843C25.5507 7.88843 27.2758 9.6136 27.2758 11.7421Z"
        fill="#7BB835"
      />
      <path
        d="M37.7306 11.7421C37.7306 13.8699 36.0046 15.5959 33.8769 15.5959C31.7483 15.5959 30.0232 13.8699 30.0232 11.7421C30.0232 9.61352 31.7484 7.88843 33.8769 7.88843C36.0047 7.88843 37.7306 9.6136 37.7306 11.7421Z"
        fill="#15539F"
      />
      <path d="M81.7749 9.86719H99.0123V13.6172H81.7749V9.86719Z" fill="#51565C" />
      <path
        d="M102.473 0.260104H7.52716C3.37708 0.260104 -0.000488281 3.63596 -0.000488281 7.78603V72.2153C-0.000488281 76.3654 3.37537 79.7412 7.52544 79.7412H102.471C106.621 79.7412 109.997 76.3654 109.997 72.2153V55.7395L109.998 42.0621V7.78496C110 3.63489 106.623 0.259033 102.473 0.259033L102.473 0.260104ZM106.25 31.7537V72.2151C106.25 74.2977 104.556 75.991 102.474 75.991H7.52587C5.44327 75.991 3.74823 74.2968 3.74823 72.2142V21.8121H106.248L106.25 31.7537ZM106.25 18.0627H3.74823V7.78625C3.74823 5.70365 5.44158 4.01032 7.52415 4.01032H102.47C104.552 4.01032 106.246 5.70367 106.246 7.78625L106.247 18.0627H106.25Z"
        fill="#51565C"
      />
      <path
        d="M47.0072 60.7022L34.6523 48.3439L47.0072 35.9891L44.3563 33.3381L29.3496 48.3439L44.3563 63.3531L47.0072 60.7022Z"
        fill="#51565C"
      />
      <path
        d="M65.6457 63.3529L80.6515 48.3437L65.6457 33.3379L62.9939 35.9888L75.3488 48.3437L62.9939 60.702L65.6457 63.3529Z"
        fill="#51565C"
      />
      <path
        d="M57.43 34.1157L61.0135 35.2223L52.5659 62.5823L48.9824 61.4757L57.43 34.1157Z"
        fill="#53A2D9"
      />
    </Svg>
  )
)

ApiIcon.propTypes = commonPropTypes
ApiIcon.defaultProps = commonDefaultProps

export default ApiIcon
